import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "form-field-floating full my-5" }
const _hoisted_2 = ["value"]

import { reactive, ref, watch } from 'vue';
    import ConfirmationModal from '@/components/ConfirmationModal.vue';
    import { AMOUNT_FORMAT_CONFIG, INTEGER_FORMAT_CONFIG, PERCENTAGE_FORMAT_CONFIG } from '@/utils';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'MarketProduitFormPricesView',
  props: {
        modelValue: { type: Object, default: null },
        startupFormDatas: { type: Object, required: true },
    },
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

    // @ts-expect-error raison: lib externe mal typée
    const props = __props;
    const emit = __emit;
    const confirmationModalRef = ref<InstanceType<typeof ConfirmationModal> | null>(null);
    const loading = ref(false);
    const formData = reactive({
        echeances: [] as any[],
        mode_paiement: 'cash',
    });
    let paymentsOptions: any[] = [];

    watch(props, () => {
        if (props.modelValue) {
            Object.assign(formData, props.modelValue);
            if (formData.echeances.length > 0) {
                formData.echeances.forEach((echeance, index) => {
                    onEcheanceChanged(index);
                });
            }
            paymentsOptions = [
                { value: 'comptant', text: 'Paiement cash' },
                { value: 'echelonne', text: `Paiement par échéances (${props.startupFormDatas.market_echeances_time} mensualités)` },
                { value: 'mixed', text: `Paiement cash & par échéances (${props.startupFormDatas.market_echeances_time} mensualités)` },
            ];
        }
    }, { deep: true });

    watch(formData, () => {
        emit('update:modelValue', formData);
    }, { deep: true });

    function addEcheance() {
        formData.echeances.push({
            duration: null,
            taux_interet: 0,
            montant_mensualite: 0,
            nombre_mensualites: 0,
            montant_total: 0,
        });
    }

    async function onRemoveEcheance(echeanceIndex: number) {
        const confirmation = await confirmationModalRef.value?.open("Suppression Echéance", "Voulez-vous vraiment supprimer l'échéance sélectionnée ?");
        if (confirmation) {
            formData.echeances.splice(echeanceIndex, 1);
        }
    }

    function onEcheanceChanged(index: number) {
        const selectedEcheance = props.startupFormDatas.echeances.find((echeance: any) => echeance.value === formData.echeances[index].duration);
        if (selectedEcheance) {
            formData.echeances[index].montant_total = parseFloat(props.startupFormDatas.produit.montant) * (1 + (formData.echeances[index].taux_interet / 100));
            formData.echeances[index].montant_mensualite = formData.echeances[index].montant_total / selectedEcheance.coef;
            formData.echeances[index].nombre_mensualites = selectedEcheance.coef;
        }
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _cache[2] || (_cache[2] = _createElementVNode("h5", { class: "flex align-items-center gap-4 font-medium text-primary-color my-5" }, " Gestion des échéances ", -1)),
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("select", {
        class: "form-input-select",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.mode_paiement) = $event)),
        name: "mode_paiement",
        id: "mode_paiement"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(paymentsOptions), (option, index) => {
          return (_openBlock(), _createElementBlock("option", {
            value: option.value,
            key: 'option_' + index
          }, _toDisplayString(option.text), 9, _hoisted_2))
        }), 128))
      ], 512), [
        [_vModelSelect, formData.mode_paiement]
      ]),
      _cache[1] || (_cache[1] = _createElementVNode("label", { for: "mode_paiement" }, [
        _createTextVNode("Mode de paiement "),
        _createElementVNode("b", { class: "color-danger" }, "*")
      ], -1))
    ])
  ]))
}
}

})